export default {
  baseStyle: {},
  defaultProps: {},
};
